var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fields.length > 0)?_c('ul',{staticClass:"audit-value"},_vm._l((_vm.fields),function(field,i){return _c('li',{key:i},[_c('span',{staticClass:"text-gray"},[_vm._v(_vm._s(field.key))]),_vm._v(" "+_vm._s(field.value)+" ")])}),0):_c('span',[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }